/* AWS Cognito Exceptions
   API Reference - https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ForgotPassword.html
*/
export const amplifyPasswordExceptionCodes = Object.freeze({
  password: {
    EXPIRED_CODE_EXCEPTION: 'ExpiredCodeException',
    LIMIT_EXCEEDED_EXCEPTION: 'LimitExceededException',
    USER_NOT_FOUND_EXCEPTION: 'UserNotFoundException',
    INVALID_PASSWORD_EXCEPTION: 'InvalidPasswordException',
    NOT_AUTHORIZED_EXCEPTION: 'NotAuthorizedException',
  },
})

export const amplifyException = Object.freeze({
  USER_IS_NOT_AUTHENTICATED: 'The user is not authenticated',
})

export const cognitoUserStatus = Object.freeze({
  CONFIRMED: 'CONFIRMED',
  FORCE_CHANGE_PASSWORD: 'FORCE_CHANGE_PASSWORD',
})

export const amplifyLoginExceptions = Object.freeze({
  USER_IS_DISABLED: 'NotAuthorizedException: User is disabled.',
})
